import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CommonService } from './common.service';
import { MessageService } from './message.service';

import { environment } from '../../environments/environment';

@Injectable()
export class MailService {

  from_page:string="";
  temp_send_list :any=[];

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService
  ) { }

  private httpOptions = this.commonService.httpOptions;
  private Options  = this.commonService.Options;

  getMailList (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/mail/mail_all/' + param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('person_all', []))
      );
  }
  //会社から選択
  getCompanyList (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/mail/company/' + param.eid + '/'+ param.cid + '/'  + param.slist + '/' + param.ylist + '/' ,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('person_all', []))
      );
  }
  //所属から選択
  getSyozokuList (param:any){
    if(param.search_text==""){param.search_text = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/mail/syozoku/' + param.eid + '/'+ param.cid + '/'  + param.slist + '/' + param.ylist + '/'  + param.search_text,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('person_all', []))
      );
  }
  //個人から選択
  getPersonList (param:any){
    if(param.search_text==""){param.search_text = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/mail/person/' + param.eid + '/' + param.cid + '/' + param.search_text,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('person_all', []))
      );
  }
  //所属から選択
  getSyozokuMailList (syozoku_array:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/mail/syozoku_by_t_syozoku_id/' + syozoku_array,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('person_all', []))
      );
  }
  //送信済メールリストを取得
  getSendlist(id:number){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/mail/sendlist/' + id,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('person_all', []))
      );
  }
  send (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/mail/send',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveEvent', []))
      );
  }
  uploadFile(file_data:any){
    return this.http.post(environment.apiUrl+'/api/mail/file',file_data)
    .pipe(
      tap(Response => this.commonService.loadingEnd()),
      catchError(this.commonService.handleError('saveEvent', []))
    );
  }
  deleteFile (file_data:any){
    return this.http.post(environment.apiUrl+'/api/mail/delete_file',file_data,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteEvent', []))
      );
  }
  save (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/mail/save',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveEvent', []))
      );
  }
  delete (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/mail/delete',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteEvent', []))
      );
  }
  templateReload (){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/mail/reload_template')
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('person_all', []))
      );
  }
  historyReload (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/mail/reload_history/' + param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('person_all', []))
      );
  }
  saveTask (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/mail/save_mail_task',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('save_mail_task', []))
      );
  }
  deleteTask (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/mail/delete_mail_task',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('save_mail_task', []))
      );
  }
  // 送信リストを取得
  getSendPerson (id:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/mail/send_person/' + id ,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('send_person', []))
      );
  }
  // タスク情報を取得
  getTaskSetting (id:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/mail/task_setting/' + id ,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('send_person', []))
      );
  }

  sendTeamsUrl (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/mail/send_teamsurl',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('sendTeamsUrl', []))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/mail.service.ts